import { Sort } from '../_enums/sort.enum';

/**
 * A class to store sort options
 */
export class SortOption {
  /**
   * Constructor
   * @param key - The object property to use for sorting
   * @param order - The sort order
   */
  constructor(public key: string, public order: Sort) {}
}
